import React, { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

const defaultValue = {
  isActive: false,
  palette: {
    background: '#050308',
    surface: '#0f0f16',
    text: '#f8f5ee',
    accent: '#f7c654'
  },
  message: {
    headline: 'Black Friday',
    body: 'Plan weekday magic at Belvoir Castle and enjoy effortless savings with our Family Saver.',
    ctaLabel: 'Discover Christmas',
    ctaLink: '/christmas'
  }
};

const BlackFridayContext = createContext(defaultValue);

export const BlackFridayProvider = ({ isActive, children }) => {
  const value = useMemo(() => {
    if (!isActive) {
      return defaultValue;
    }

    return {
      isActive: true,
      palette: {
        background: '#050308',
        surface: 'rgba(8, 8, 12, 0.85)',
        text: '#f8f5ee',
        accent: '#f7c654'
      },
      message: {
        headline: 'Black Friday: 20% Off Entry and Santa Tickets + Additional Family Saving',
        body: 'Add your visiting party, watch the savings unlock, and secure the most dramatic castle Christmas yet.',
        ctaLabel: 'Unlock 20% Off',
        ctaLink: '/christmas/your-festive-visit'
      }
    };
  }, [isActive]);

  return (
    <BlackFridayContext.Provider value={value}>
      {children}
    </BlackFridayContext.Provider>
  );
};

BlackFridayProvider.propTypes = {
  isActive: PropTypes.bool,
  children: PropTypes.node.isRequired
};

BlackFridayProvider.defaultProps = {
  isActive: false
};

export const useBlackFriday = () => useContext(BlackFridayContext);

export default BlackFridayContext;

